import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { tableCellClasses } from "@mui/material/TableCell";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Collapse from "@mui/material/Collapse";
import { useGetAPIQuery, useLazyGetAPIQuery } from "../Api/api";
import {
  READ_ALL_OFFER,
  READ_ALL_ORDERS,
  READ_ITEMS_FROM_CART,
  GET_ORDER_BY_ID,
  DOWNLOAD_QR_CODE
} from "../Api/apiConstant";
import Navbar from "../components/Navbar";
import store from "../Images/ic-order-info.png";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Sidebar from "./Sidebar";
import calender from "../Images/calender-1.png";
import user from "../Images/ic-user-white.png";
import clock from "../Images/Clock.png";
import moment from "moment/moment";
import API_URL from "../ServiceModule/Service";
import CustomButton from "../components/CustomButton";
import { useSelector } from "react-redux";
import { styled, alpha } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Footer from "../components/Footer";
import { useThemeColors } from "../Context/Theme";
import ageImageFlage from "../Images/Red-flag.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CardContent, Divider, Stack } from "@mui/material";
import { isMobile } from "../global/helpers";
import axios from "axios";
import { skipToken } from "@reduxjs/toolkit/query";
import { getToken, getUserId } from "../LoginModule/LoginUtility";

const TAX_RATE = 0;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: "0.9rem",
  },
}));

const MyOrder = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const getOrderId = sessionStorage.getItem("orderId");
  const token = getToken()
  const eventId = sessionStorage.getItem("event_id");
  const userId = getUserId()
  const products = useSelector((state) => state.cart.items);
  const cartItem = useSelector((state) => state.cart.items);
  const [cartList, setCartList] = useState([]);
  const [cartDiscount, setCartDiscount] = useState([]);
  const [categoryWiseTaxes, setCategoryWiseTaxes] = useState([]);
  const [render, setRender] = useState(false);
  const [visibleOrders, setVisibleOrders] = useState(4);
  const [dialog, setDialog] = useState({ open: false, content: null });
  const [order, setOrder] = useState(null);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [currentQRCodeurl, setCurrentQRCodeurl] = useState(null);
  const [orderDetails, setOrderDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [orderStatus, setOrderStatus] = useState(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const { data, isLoading, isError, error } = useGetAPIQuery({
    url: `${READ_ALL_ORDERS}user_id=${userId}`,
    token: token,
  });

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontFamily: fontFamily || "poppins !important",
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#F9FAFD",
      color: theme.palette.common.black,
      fontSize: fontSize || "1rem",
      fontWeight: fontWeight || 600,
      gap: "8px",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: fontSize || 16,
      fontWeight: fontWeight || 500,
      color: "#646363",
    },
  }));
  const [id, setId] = useState(() => {
    const url = window.location.href;
    const segments = url.split("/");
    return segments.pop();
  });


  const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

  const handleDialogOpen = async (orderId) => {

    try {
      const response = await fetch(
        `${API_URL}${READ_ITEMS_FROM_CART}order_id=${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setOrderDetails(data);
      setDialog({ open: true, content: null });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const {
    data: orderData,
  } = useGetAPIQuery(
    orderDetails?.order_id ? {
      url: `${GET_ORDER_BY_ID}?order_id=${orderDetails?.order_id}`,
      token: token,
    } : skipToken,

  );

  const { data: offerList, isSuccess } = useGetAPIQuery({
    url: eventId
      ? `${READ_ALL_OFFER}?event_id=${eventId}`
      : `${READ_ALL_OFFER}`,
    token: token,
  });


  useEffect(() => {
    if (id !== "0" && id) {
      handleDialogOpen(parseInt(id));
      // Reset id in state
      setId("0");
      // Update URL param (replace last segment with "0")
      const url = new URL(window.location.href);
      const paths = url.pathname.split("/");
      paths.pop(); // remove old id
      paths.push("0"); // add "0"
      const newPathname = paths.join("/");
      url.pathname = newPathname;

      // Update the browser URL without reload
      window.history.replaceState(null, "", url.toString());
    }
  }, [id]);


  useEffect(() => {
    if (offerList?.data?.length > 0 && orderDetails?.cart_items?.length > 0) {
      const todaysDate = new Date();
      let updatedData = orderDetails?.cart_items?.map((k) => {
        const productOfferData = offerList?.data?.find(
          (n) =>
            n?.product_id === k?.product_id &&
            new Date(n?.offer_start_date) <= todaysDate &&
            todaysDate <= new Date(n?.offer_end_date)
        );
        if (productOfferData?.product_id === k?.product_id) {
          let discountedPrice = 0;
          let discountMessage = "";
          let discountType = "";
          let discountAmount = 0;

          if (productOfferData) {
            if (productOfferData.discount_fixed === "Discount") {
              const totalDiscount =
                (parseInt(k?.total_price) *
                  productOfferData.discount_fixed_amount) /
                100;
              discountType = productOfferData.discount_fixed;
              discountAmount = productOfferData.discount_fixed_amount;
              discountedPrice = totalDiscount;
              discountMessage = `Applied ${productOfferData.discount_fixed_amount}% Discount (Product Offer)`;
            } else {
              discountType = productOfferData.discount_fixed;
              discountAmount = productOfferData.discount_fixed_amount;
              discountedPrice =
                productOfferData.discount_fixed_amount * k.quantity;
              discountMessage = `Applied $${productOfferData.discount_fixed_amount} Discount (Product Offer)`;
            }
          }

          return {
            ...k,
            total: k.total_price,
            total_price: k.total_price - discountedPrice,
            discountedPrice,
            discountAmount,
            discountType,
            discountMessage,
            discountApplied: true,
          };
        }
        return k;
      });

      updatedData = updatedData?.map((k) => {
        const categoryOfferData = offerList?.data?.find(
          (n) =>
            n.category_id == k?.product_details.categories?.[0]?.category_id &&
            new Date(n.offer_start_date) <= todaysDate &&
            todaysDate <= new Date(n.offer_end_date)
        );
        if (
          categoryOfferData?.category_id ===
          k?.product_details.categories?.[0]?.category_id &&
          !k.discountApplied
        ) {
          let discountedPrice = 0;
          let discountMessage = "";
          let discountType = "";
          let discountAmount = "";

          if (categoryOfferData) {
            if (categoryOfferData.discount_fixed === "Discount") {
              const totalDiscount =
                (parseInt(k?.total_price) *
                  categoryOfferData.discount_fixed_amount) /
                100;
              discountType = categoryOfferData.discount_fixed;
              discountAmount = categoryOfferData.discount_fixed_amount;
              discountedPrice = totalDiscount;
              discountMessage = `Applied ${categoryOfferData.discount_fixed_amount}% Discount (Category Offer)`;
            } else {
              discountType = categoryOfferData.discount_fixed;
              discountAmount = categoryOfferData.discount_fixed_amount;
              discountedPrice =
                categoryOfferData.discount_fixed_amount * k.quantity;
              discountMessage = `Applied $${categoryOfferData.discount_fixed_amount} Discount (Category Offer)`;
            }
          }

          return {
            ...k,
            total: k.total_price,
            total_price: k.total_price - discountedPrice,
            discountedPrice,
            discountAmount,
            discountType,
            discountMessage,
            discountApplied: true,
          };
        }
        return k;
      });
      updatedData = updatedData?.map((k) => {
        const brandOfferData = offerList?.data?.find(
          (n) =>
            n.brand_id == k?.product_details.brands?.[0]?.brand_id &&
            new Date(n.offer_start_date) <= todaysDate &&
            todaysDate <= new Date(n.offer_end_date)
        );
        if (
          brandOfferData?.brand_id ===
          k?.product_details.brands?.[0]?.brand_id &&
          !k.discountApplied
        ) {
          let discountedPrice = 0;
          let discountMessage = "";
          let discountType = "";
          let discountAmount = "";

          if (brandOfferData) {
            if (brandOfferData.discount_fixed === "Discount") {
              const totalDiscount =
                (parseInt(k?.total_price) *
                  brandOfferData.discount_fixed_amount) /
                100;
              discountedPrice = totalDiscount;
              discountType = brandOfferData.discount_fixed;
              discountAmount = brandOfferData.discount_fixed_amount;
              discountMessage = `Applied ${brandOfferData.discount_fixed_amount}% Discount (Brand Offer)`;
            } else {
              discountType = brandOfferData.discount_fixed;
              discountAmount = brandOfferData.discount_fixed_amount;
              discountedPrice =
                brandOfferData.discount_fixed_amount * k.quantity;
              discountMessage = `Applied $${brandOfferData.discount_fixed_amount} Discount (Brand Offer)`;
            }
          }

          return {
            ...k,
            total: k.total_price,
            total_price: k.total_price - discountedPrice,
            discountedPrice,
            discountAmount,
            discountType,
            discountMessage,
            discountApplied: true,
          };
        }
        return k;
      });

      updatedData = updatedData?.map((k) => {
        const cityTaxRate =
          parseFloat(k?.product_details?.categoryTax[0]?.city_tax) || 0;
        const stateTaxRate =
          parseFloat(k?.product_details?.categoryTax[0]?.state_tax) || 0;

        const taxAmount =
          (k?.total_price * cityTaxRate) / 100 +
          (k?.total_price * stateTaxRate) / 100;

        return {
          ...k,
          taxAmount,
          total_price_with_tax: parseInt(k?.total_price) + taxAmount,
        };
      });

      const categoryTaxes = {};
      updatedData?.forEach((item) => {
        const categoryId = item.product_details.categories?.[0]?.category_id;
        const categoryName =
          item.product_details.categories?.[0]?.category_name;
        const categoryTaxRates = {
          cityTax: parseFloat(item.product_details.city_tax) || 0,
          stateTax: parseFloat(item.product_details.state_tax) || 0,
        };

        if (!categoryTaxes[categoryId]) {
          categoryTaxes[categoryId] = {
            categoryName,
            totalAmount: 0,
            totalTax: 0,
            categoryTaxRates,
          };
        }

        const categoryTotalPrice = parseInt(item?.total_price);
        const categoryTaxAmount =
          (categoryTotalPrice * categoryTaxRates.cityTax) / 100 +
          (categoryTotalPrice * categoryTaxRates.stateTax) / 100;

        categoryTaxes[categoryId].totalAmount += categoryTotalPrice;
        categoryTaxes[categoryId].totalTax += categoryTaxAmount;
      });

      const categoryTaxArray = Object.values(categoryTaxes);
      setCategoryWiseTaxes(categoryTaxArray);

      setCartList(updatedData);
    }
  }, [orderDetails]);

  const bundle =
    orderDetails?.order_data?.products?.filter(
      (item, index) => item?.product_id === null
    ) || [];

  const totalDiscountPriceAmount = [...cartList, ...bundle]?.reduce(
    (sum, item) =>
      sum + isNaN(item.total_price) ? 0 : parseFloat(item.total_price),
    0
  );

  useEffect(() => {
    if (offerList?.data?.length > 0 && orderDetails?.cart_items?.length > 0) {
      const todaysDate = new Date();
      let totalCartAmount = totalDiscountPriceAmount;

      let appliedDiscounts = [];
      let minimumPurchaseDiscount = 0;

      const minimumPurchaseOffer = offerList?.data?.find(
        (offer) =>
          offer.minimumpurchase === true &&
          new Date(offer?.offer_start_date) <= todaysDate &&
          todaysDate <= new Date(offer?.offer_end_date)
      );

      if (minimumPurchaseOffer) {
        const sitewideAmount = parseFloat(
          minimumPurchaseOffer?.minimumpurchase_sitewide_amount || 0
        );
        const discountFixedAmount = parseFloat(
          minimumPurchaseOffer?.discount_fixed_amount || 0
        );

        if (totalCartAmount >= sitewideAmount) {
          if (minimumPurchaseOffer.discount_fixed === "Discount") {
            minimumPurchaseDiscount =
              (totalCartAmount * discountFixedAmount) / 100;
          } else {
            minimumPurchaseDiscount = discountFixedAmount;
          }

          totalCartAmount -= minimumPurchaseDiscount;

          appliedDiscounts.push({
            type: "Minimum Purchase",
            discount: minimumPurchaseDiscount,
            message: `Additional + $${minimumPurchaseDiscount.toFixed(2)} off`,
          });
        }
      }

      if (!minimumPurchaseDiscount) {
        const sitewideOffer = offerList?.data?.find(
          (offer) =>
            offer.sitewide === true &&
            new Date(offer.offer_start_date) <= todaysDate &&
            todaysDate <= new Date(offer.offer_end_date)
        );

        if (sitewideOffer) {
          const discountFixedAmount = Number(
            sitewideOffer.discount_fixed_amount || 0
          );

          let sitewideDiscount = 0;
          if (sitewideOffer.discount_fixed === "Discount") {
            sitewideDiscount = (totalCartAmount * discountFixedAmount) / 100;
          } else {
            sitewideDiscount = discountFixedAmount;
          }

          totalCartAmount -= sitewideDiscount;

          appliedDiscounts.push({
            type: "Sitewide",
            discount: sitewideDiscount,
            message: `additional +$${sitewideDiscount.toFixed(2)} off`,
          });
        }
      }

      if (appliedDiscounts.length === 0) {
        appliedDiscounts.push({
          type: "No Discount",
          discount: 0,
          message: "No Discounts Applied",
        });
      }

      if (orderDetails) {
        setCartDiscount(
          cartList?.map((item) => ({
            ...item,
            totalCartAmount,
            appliedDiscounts,
          }))
        );
      }
    }
  }, [cartList]);

  const handleDialogClose = () => {
    setDialog({ open: false, content: null });
  };

  const handleClickOpen = (order) => {
    getPresignedQRCodeURL(order.order_id);

    setOpen(true);
    setCurrentOrder(order);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentOrder(null);
  };

  const [trigger] = useLazyGetAPIQuery();
  const getPresignedQRCodeURL = async (orderId) => {
    try {
      const response = await axios.get(`${API_URL}${DOWNLOAD_QR_CODE}?order_id=${orderId}&mode=presigned`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (response.data) {
        setCurrentQRCodeurl(response.data?.url);
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  }
  const handleDownload = async (orderId) => {
    try {

      const link = document.createElement("a");
      link.href = currentQRCodeurl;
      link.download = `qrcode_${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const productsQuantity = orderData?.order_data?.products?.reduce(
    (total, item) => total + item.productQuantity,
    0
  );
  const bundleQuantity = orderData?.order_data?.bundles?.reduce(
    (total, item) => total + item.bundleQuantity,
    0
  )
  const totalQuantity = productsQuantity + bundleQuantity;

  function getTaxAmountValue(knownPercent, knownValue, targetPercent) {
    const originalValue = knownValue / (knownPercent / 100);
    return (targetPercent / 100) * originalValue;
  }

  return (
    <div
      className="overflow-hidden"
      style={{ backgroundColor: backgroundColor }}
    >
      <Navbar className="sticky-navbar" />
      <Grid
        container
        spacing={4}
        style={{ margin: isMobile() ? "2% 0" : "2% 4%", marginTop: "18vh" }}
      >
        {
          isMobile()
            ? <Sidebar />
            : <Grid item xs={12} sm={10} md={2} className="">
              <Sidebar />
            </Grid>
        }
        <Grid item xs={12} sm={10} md={9}>
          {dialog.open ? (
            <>
              <Container maxWidth="xl">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      cursor: "pointer",
                      marginRight: "1rem",
                    }}
                    onClick={handleDialogClose}
                  >
                    <ArrowBackIcon />
                  </div>
                  <span style={{ fontSize: fontSizeHeading || "1.5em", fontWeight: fontWeightHeading || "700", fontFamily: fontFamilyHeading }}>
                    Order Summary
                  </span>
                </div>
                <Card
                  className="p-4"
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    width: isMobile() ? "90%" : "100%"
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          md={7}
                          direction={"column"}
                          style={{ display: "flex", gap: 15 }}
                        >
                          <Typography
                            gutterBottom
                            style={{
                              fontSize: "20px",
                              fontWeight: "600",
                              fontFamily: fontFamily || "Poppins, sans-serif",
                            }}
                          >
                            Order ID : {orderDetails?.order_id}
                          </Typography>
                          <Typography
                            gutterBottom
                            style={{
                              fontWeight: "600",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "16px",
                              fontFamily: fontFamily || "Poppins, sans-serif",
                            }}
                          >
                            <img
                              src={calender}
                              width={25}
                              style={{ marginRight: "8px" }}
                            />
                            {moment(orderDetails?.order_created_date).format(
                              "MMM DD, YYYY"
                            )}
                          </Typography>
                        </Grid>
                        <Grid
                          md={5}
                          style={{
                            display: "flex",

                            justifyContent: "end",
                            marginTop: "10px",
                            paddingRight: "10px"
                          }}
                        >
                          <Typography
                            variant="h6"
                            style={{
                              fontWeight: fontWeight || 600,
                              fontSize: fontSize || "18px",
                              fontFamily
                            }}
                          >
                            Order Status : <strong style={{
                              color: orderDetails?.order_status == "Delivered"
                                ? "#4EA240"
                                : orderDetails?.order_status == "Pending"
                                  ? "#FFCE20"
                                  : orderDetails?.order_status == "Cancel"
                                    ? "#FF1C1C"
                                    : "",
                              fontFamily,
                              fontSize,
                              fontWeight
                            }}>{orderDetails?.order_status == "Cancel" ? "Cancelled" : orderDetails?.order_status}</strong>
                          </Typography>
                        </Grid>
                        <Grid container spacing={2} mt={1} alignItems="stretch">
                          {[
                            {
                              title: orderData?.event_name,
                              details: [
                                { title: "Event Address", value: orderData?.event_address },
                                { title: "City", value: orderData?.city },
                                { title: "County", value: orderData?.country },
                              ],
                              icon: store,
                            },
                            {
                              title: "Order Info",
                              details: [
                                { title: "Quantity", value: totalQuantity },
                                { title: "Payment Method", value: "Square" },
                                { title: "Status", value: orderData?.order_status },
                              ],
                              icon: store,
                            },
                            {
                              title: "Customer",
                              details: [
                                { title: "Full Name", value: orderData?.user_name },
                                { title: "Email", value: orderData?.order_data?.user_email },
                                { title: "Phone", value: orderData?.phone_number },
                              ],
                              icon: user,
                            },
                            {
                              title: "Payment Info",
                              details: [
                                { title: "Square" },
                                { title: "Payment ID", value: orderData?.payment_id },
                                { title: "Payment Status", value: orderData?.payment_status },
                              ],
                            },
                            {
                              title: "Verification ID",
                              details: [
                                { title: "ID Type", value: orderData?.document_type },
                              ],
                              image: orderData?.document_img ? (orderData?.document_img.startsWith('http://') || orderData?.document_img.startsWith('https://'))
                                ? orderData?.document_img
                                : `data:image/jpeg;base64,${orderData?.document_img}`
                                : null,
                            },
                            ...(orderData?.orderStatusDetails?.order_status == "Cancel" ? [{
                              title: "Refund Info",
                              details: [
                                { title: "Refund Status", value: orderData?.refund_status },
                                { title: "Refund Amount", value: orderData?.refund_amount },
                                { title: "Refund Id", value: orderData?.refund_id },
                              ],
                              image: orderData?.document_img,
                            }] : [])
                          ].map((card, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              key={index}
                              className="mt-2"
                            >
                              <Card
                                elevation={0}
                                className="p-3"
                                style={{
                                  height: "100%",
                                  borderRadius: "16px",
                                  border: "1px solid #E7E7E3",
                                }}
                              >
                                {card.icon && (
                                  <Grid container spacing={1}>
                                    <Grid
                                      item
                                      sx={{
                                        maxWidth: "max-content",
                                        height: "max-content",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                          backgroundColor: "#232321",
                                          borderRadius: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <img src={card.icon} width={25} />
                                      </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                      <Typography
                                        gutterBottom
                                        style={{
                                          fontWeight: fontWeight || "600",
                                          fontSize: fontSize || "20px",
                                          fontFamily
                                        }}
                                      >
                                        {card.title}
                                      </Typography>
                                      {card.details.map((detail, i) => (
                                        detail.title === "Event Address" || detail.title === "Email" || detail.title === "Full Name" ? <Tooltip
                                          title={detail.value || detail.title}
                                          key={i}
                                          placement="top"
                                          arrow
                                        >
                                          <Typography
                                            gutterBottom
                                            style={{
                                              fontWeight: fontWeight || "500",
                                              fontSize: fontSize || "14px",
                                              color: "#949492",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              fontFamily
                                            }}
                                          >
                                            {detail.value ? `${detail.title}: ${detail.value}` : detail.title}
                                          </Typography>
                                        </Tooltip> : <Typography
                                          gutterBottom
                                          style={{
                                            fontWeight: fontWeight || "500",
                                            fontSize: fontSize || "14px",
                                            color: "#949492",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontFamily
                                          }}
                                        >
                                          {detail.value ? `${detail.title}: ${detail.value}` : detail.title}
                                        </Typography>
                                      ))}
                                    </Grid>
                                  </Grid>
                                )}
                                {!card.icon && (
                                  <>
                                    <Typography
                                      gutterBottom
                                      style={{
                                        fontWeight: fontWeight || "600",
                                        fontSize: fontSize || "20px",
                                        fontFamily
                                      }}
                                    >
                                      {card.title}
                                    </Typography>
                                    {card.details.map((detail, i) => (
                                      detail.title === "Payment ID" ? <Tooltip
                                        title={detail.value || detail.title}
                                        key={i}
                                        placement="top"
                                        arrow
                                      >
                                        <Typography
                                          gutterBottom
                                          style={{
                                            fontWeight: fontWeight || "500",
                                            fontSize: fontSize || "14px",
                                            color: "#949492",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontFamily
                                          }}
                                        >
                                          {detail.value ? `${detail.title}: ${detail.value}` : detail.title}
                                        </Typography>
                                      </Tooltip> :
                                        detail.title === "Refund Id" ?
                                          <Tooltip
                                            title={detail.value || detail.title}
                                            key={i}
                                            placement="top"
                                            arrow
                                          >
                                            <Typography
                                              gutterBottom
                                              style={{
                                                fontWeight: fontWeight || "500",
                                                fontSize: fontSize || "14px",
                                                color: "#949492",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontFamily
                                              }}
                                            >
                                              {detail.value ? `${detail.title}: ${detail.value}` : detail.title}
                                            </Typography>
                                          </Tooltip>
                                          :
                                          <Typography
                                            gutterBottom
                                            style={{
                                              fontWeight: fontWeight || "500",
                                              fontSize: fontSize || "14px",
                                              color: "#949492",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              fontFamily
                                            }}
                                          >
                                            {detail.value ? `${detail.title}: ${detail.value}` : detail.title}
                                          </Typography>
                                    ))}
                                    {card.title === "Verification ID" && card.image && (
                                      <img src={card.image} width={150} />
                                    )}
                                  </>
                                )}
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Container>
              <Container maxWidth="xl">
                <Card
                  className="p-4 mt-4"
                  elevation={0}
                  style={{ borderRadius: "16px" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid item xs={12} md={12}>
                        <Typography
                          gutterBottom
                          style={{
                            fontSize: fontSizeHeading || "20px",
                            fontWeight: fontWeightHeading || "700",
                            fontFamily: fontFamilyHeading || "Poppins, sans-serif",
                            marginBottom: "12px"
                          }}
                        >
                          Products
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"flex-end"}
                        gap={3}
                      >
                        <Grid item xs={12} md={12}>
                          <TableContainer
                            component={Paper}
                            sx={{
                              borderRadius: "14px",
                              boxShadow: "none",
                              borderStyle: "solid",
                              borderWidth: "0.5px",
                              borderColor: "#E0E0E0",

                            }}
                            style={{ borderRadius: "16px" }}
                          >
                            <Table
                              sx={{ minWidth: 700 }}
                              aria-label="customized table"
                            >
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell className="product-name" style={{ fontFamily }}>
                                    Product Name
                                  </StyledTableCell>
                                  <StyledTableCell className="age-img" style={{ fontFamily }}>
                                  </StyledTableCell>
                                  {/* <StyledTableCell className="order-id">
                              Order Id
                            </StyledTableCell> */}
                                  <StyledTableCell className="quantity" style={{ fontFamily }}>
                                    Quantity
                                  </StyledTableCell>
                                  <StyledTableCell className="total" style={{ fontFamily }}>
                                    Total
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {(orderData?.order_data?.products || [])?.concat(orderData?.order_data?.bundles)?.map((row, index) => {
                                  const isBundle = row?.bundleProducts?.length > 0
                                  return <React.Fragment key={index}>
                                    <StyledTableRow>
                                      <StyledTableCell>
                                        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 7, height: "100%", width: "100%", marginLeft: isBundle ? "0" : "2em" }}>
                                          {isBundle && <p
                                            onClick={() =>
                                              setExpandedRows(
                                                expandedRows === index
                                                  ? null
                                                  : index
                                              )
                                            }
                                          >
                                            {expandedRows === index ? (
                                              <RemoveIcon className="mt-3" style={{ cursor: 'pointer' }} />
                                            ) : (
                                              <AddIcon className="mt-3" style={{ cursor: 'pointer' }} />
                                            )}
                                          </p>}
                                          <img
                                            src={row?.productImage || ""}
                                            alt={`Product_Img of ${row?.productName}}`}
                                            width="15%"
                                            height="15%"
                                            style={{
                                              border: "1px solid #E0E0E0",
                                              borderRadius: "8px",
                                              padding: "2px",
                                              marginRight: "0.3em",
                                              maxWidth: "40px",
                                              maxHeight: "40px",

                                            }}
                                          />

                                          <div style={{ display: "flex", flexDirection: "column", fontFamily }}>
                                            <span style={{ fontFamily }}>
                                              {row?.productName}
                                            </span>
                                            <span style={{ fontFamily }} >
                                              {row?.productUnit}
                                            </span>
                                          </div>

                                        </div>
                                      </StyledTableCell>

                                      <StyledTableCell>
                                        {(isBundle
                                          ? false
                                          : row?.productAgeValidation !== "No") && (
                                            <div
                                              style={{
                                                width: "15%",
                                                height: "15%",
                                                zIndex: 1,
                                                color: "white",
                                                fontWeight: "bold",
                                                position: "relative"
                                              }}
                                            >
                                              <img src={ageImageFlage} style={{ width: "100%", height: "100%" }} />
                                              <p style={{ fontSize: "0.8rem", margin: 0, position: "absolute", zIndex: 5, transform: "translateY(-20%)", top: "20%", left: "50%", transform: "translateX(-50%)" }}>
                                                {row?.productAgeValidation}+<br />
                                                {/* only */}
                                              </p>
                                            </div>
                                          )}
                                      </StyledTableCell>
                                      <StyledTableCell style={{ fontFamily }}>
                                        {row?.productQuantity}
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        {
                                          row?.productRegularPrice == row?.productDiscountedPrice ?
                                            <strong style={{ fontFamily }}>${parseFloat(row?.productRegularPrice).toFixed(2)}</strong>
                                            :
                                            <>
                                              <p
                                                style={{
                                                  textDecoration: "line-through",
                                                  fontSize: "0.8rem",
                                                  fontFamily
                                                }}
                                              >
                                                $
                                                {row?.productRegularPrice}
                                              </p>
                                              <strong style={{ fontFamily }}>${parseFloat(row?.productDiscountedPrice).toFixed(2)}</strong>
                                            </>
                                        }
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </React.Fragment>

                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    style={{ display: "flex", gap: "20px", marginTop: "36px" }}
                    container
                    alignItems="center"
                    justifyContent="flex-end"
                    item
                    xs={12}
                    md={12}
                  >

                    <Grid
                      item
                      xs={12}
                      md={4}
                      lg={4}
                      alignContent={"center"}
                      justifyContent={"flex-end"}
                      style={{ borderRadius: "16px", border: "1px solid #ccc" }}
                    >
                      <Typography
                        gutterBottom
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: fontFamily || "Poppins, sans-serif",
                          padding: "0.5em",
                          textAlign: "center",
                        }}
                      >
                        Order Summary
                      </Typography>
                      <Card
                        elevation={0}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          borderRadius: "16px",
                          paddingBottom: "0px",
                        }}
                      >
                        <CardContent
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Stack
                            spacing={2}
                            justifyContent={"center"}
                            alignItems={"center"}
                            width={"100%"}
                          >
                            <Stack
                              direction={"row"}
                              width={"100%"}
                              justifyContent={"space-between"}
                              spacing={2}
                            >
                              <Typography
                                gutterBottom
                                style={{
                                  color: "black",
                                  fontWeight: "500",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: "16px",
                                  width: "65%",
                                }}
                              >
                                Sub Total
                              </Typography>
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "600",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: "14px",
                                  color: "rgb(72, 72, 72)",
                                  width: "30%",
                                  textAlign: "right",
                                  textDecoration:
                                    orderDetails?.sub_totalprice !=
                                    parseFloat(
                                      orderDetails?.discount_totalprice
                                    ).toFixed(2) && "line-through",
                                }}
                              >
                                $
                                {isNaN(orderDetails?.sub_totalprice)
                                  ? 0
                                  : parseFloat(
                                    orderDetails?.sub_totalprice
                                  ).toFixed(2)}
                              </Typography>
                            </Stack>
                            <Stack
                              direction={"row"}
                              width={"100%"}
                              justifyContent={"space-between"}
                              spacing={2}
                            >
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "600",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: "0.8rem",
                                  color: "green",
                                  width: "65%",
                                }}
                              >
                                Discount
                                {
                                  orderDetails?.discount_details?.discountBreakdown?.length > 0 && (
                                    <LightTooltip
                                      placement="right-start"
                                      title={
                                        <div>
                                          {orderDetails?.discount_details?.discountBreakdown?.map(discountData => {
                                            return (
                                              <>
                                                <div
                                                  style={{
                                                    fontWeight: "600",
                                                    fontSize: "0.8rem",
                                                    fontFamily,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  { }
                                                  <span
                                                    style={{
                                                      fontSize: "0.6rem",
                                                      fontWeight: "600",
                                                      fontFamily
                                                    }}
                                                  >
                                                    {discountData?.discountTitle}
                                                  </span>
                                                  <span
                                                    style={{
                                                      whiteSpace: "pre-wrap",
                                                      display: "block",
                                                      marginLeft: "2vw",
                                                      fontSize: "0.6rem",
                                                      fontFamily,
                                                      color: "green"
                                                    }}
                                                  >
                                                    {" "}
                                                    $
                                                    <strong style={{ fontSize: "0.6rem", fontFamily }}>

                                                      {discountData?.amount}
                                                    </strong>
                                                  </span>
                                                </div>
                                              </>
                                            )
                                          })}
                                        </div>
                                      }
                                    >
                                      <InfoOutlinedIcon
                                        fontSize="small"
                                        sx={{ cursor: "pointer", marginLeft: '12px' }}
                                      />
                                    </LightTooltip>
                                  )
                                }
                              </Typography>
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "600",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: "0.7rem",
                                  color: "green",
                                  width: "30%",
                                  textAlign: "right",
                                }}
                              >
                                ${parseFloat(orderDetails?.discount).toFixed(2)}
                              </Typography>
                            </Stack>
                            {parseFloat(orderData?.order_data?.bundleDiscount) > 0 &&
                              <Stack direction={"row"} width={"100%"} justifyContent={"space-between"} spacing={2}>
                                <Typography
                                  gutterBottom
                                  style={{
                                    fontWeight: "600",
                                    fontFamily: "poppins",
                                    fontSize: "0.8rem",
                                    color: "green",
                                    width: "65%",
                                  }}
                                >
                                  Bundle Discount
                                </Typography>
                                <Typography
                                  gutterBottom
                                  style={{
                                    fontWeight: "600",
                                    fontFamily: "poppins",
                                    fontSize: "0.7rem",
                                    color: "green",
                                    width: "30%",
                                    textAlign: "right",
                                  }}
                                >
                                  ${parseFloat(orderData?.order_data?.bundleDiscount).toFixed(2)}
                                </Typography>
                              </Stack>}
                            {
                              orderDetails?.order_data?.promocode?.promocodeDiscount > 0 &&
                              <Stack
                                direction={"row"}
                                width={"100%"}
                                justifyContent={"space-between"}
                                spacing={2}
                              >
                                <Typography
                                  gutterBottom
                                  style={{
                                    fontWeight: "600",
                                    fontFamily: fontFamily || "poppins",
                                    fontSize: "0.8rem",
                                    color: "green",
                                    width: "65%",
                                  }}
                                >
                                  Promocode
                                </Typography>
                                <Typography
                                  gutterBottom
                                  style={{
                                    fontWeight: "600",
                                    fontFamily: fontFamily || "poppins",
                                    fontSize: "0.7rem",
                                    color: "green",
                                    width: "30%",
                                    textAlign: "right",
                                  }}
                                >
                                  ${parseFloat(orderDetails?.order_data?.promocode?.promocodeDiscount).toFixed(2)}
                                </Typography>
                              </Stack>
                            }
                            {orderDetails?.total_order_price !=
                              parseFloat(
                                orderDetails?.discount_totalprice
                              ).toFixed(2) && (
                                <Stack
                                  direction={"row"}
                                  width={"100%"}
                                  justifyContent={"space-between"}
                                  spacing={2}
                                >
                                  <Typography
                                    gutterBottom
                                    style={{
                                      fontWeight: "600",
                                      fontFamily: fontFamily || "poppins",
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    Discounted Amount
                                  </Typography>
                                  <Typography
                                    gutterBottom
                                    style={{
                                      fontWeight: "600",
                                      fontFamily: fontFamily || "poppins",
                                      fontSize: "1rem",
                                      width: "50%",
                                      textAlign: "right",
                                    }}
                                  >
                                    $
                                    {isNaN(orderDetails?.discount_totalprice)
                                      ? 0
                                      : parseFloat(
                                        orderDetails?.discount_totalprice
                                      ).toFixed(2)}
                                  </Typography>
                                </Stack>
                              )}

                            <Stack
                              alignItems={"center"}
                              width={"100%"}
                              justifyContent={"space-between"}
                              direction={"row"}
                              spacing={2}
                            >
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "600",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: ".8rem",
                                  color: "red",
                                }}
                              >
                                Total taxes
                                {
                                  orderDetails?.tax_details?.finalTaxDetails?.length > 0 && (
                                    <LightTooltip
                                      placement="right-start"
                                      title={
                                        <div>
                                          {orderDetails?.tax_details?.finalTaxDetails?.map((tax, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "0.8em",
                                                fontFamily,
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "0.8em",
                                                  fontFamily,
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <strong style={{ fontSize: "1.2em", fontFamily }}>
                                                  {tax.type} Tax {tax?.type === "Custom" ? <span className="text-danger"><br />{orderDetails?.tax_details?.customNameList}</span> : ""}
                                                </strong>                                              </span>

                                              <span
                                                style={{
                                                  whiteSpace: "pre-wrap",
                                                  color: "red",
                                                  marginLeft: "2vw",
                                                  fontSize: "0.8em",
                                                  fontFamily,
                                                  alignItems: "flex-end",
                                                }}
                                              >
                                                <strong style={{ fontSize: "1em", fontFamily }}>
                                                  {" "}Tax Amount: ${tax?.amount}
                                                </strong>
                                              </span>
                                            </div>
                                          )
                                          )}
                                        </div>
                                      }
                                    >
                                      <InfoOutlinedIcon fontSize="small" sx={{ cursor: "pointer", marginLeft: '12px' }} />
                                    </LightTooltip>
                                  )
                                }
                              </Typography>
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "600",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: ".8rem",
                                  color: "red",
                                  width: "50%",
                                  textAlign: "right",
                                }}
                              >
                                $
                                {isNaN(orderDetails?.tax_totalprice)
                                  ? 0
                                  : parseFloat(
                                    orderDetails?.tax_totalprice
                                  ).toFixed(2)}
                              </Typography>
                            </Stack>
                            <Divider
                              style={{
                                width: "100%",
                                color: "black",
                                borderColor: "black",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            />
                            <Stack
                              alignItems={"center"}
                              width={"100%"}
                              justifyContent={"space-between"}
                              direction={"row"}
                              marginTop={"0px !important"}
                              spacing={2}
                            >
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "500",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: "16px",
                                  color: "#000",
                                }}
                              >
                                Total Price:
                              </Typography>
                              <Typography
                                gutterBottom
                                style={{
                                  fontWeight: "700",
                                  fontFamily: fontFamily || "poppins",
                                  fontSize: "16px",
                                  color: "#000",
                                  width: "50%",
                                  textAlign: "right",
                                }}
                              >
                                $
                                {isNaN(orderDetails?.cart_totalprice)
                                  ? 0
                                  : parseFloat(
                                    orderDetails?.cart_totalprice
                                  ).toFixed(2)}
                              </Typography>
                            </Stack>
                          </Stack>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </Container>
            </>
          ) : (
            <Card
              className={isMobile() ? 'p-3' : "p-5"}
              style={{
                height: "94vh",
                overflowY: "auto",
                borderRadius: "21px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px",
              }}
            >
              <p style={{ fontSize: fontSizeHeading || "28px", fontWeight: fontWeightHeading || "600", fontFamily: fontFamilyHeading }}>
                My Orders {data?.data?.length && data?.data?.length > 0 ?
                  "(" + data?.data?.length + ")"
                  : ''}
              </p>
              {isLoading ? (
                <Grid
                  container
                  spacing={4}
                  style={{
                    height: "30vh",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress color="secondary" />
                </Grid>
              ) : error ? (
                <Grid
                  container
                  spacing={4}
                  style={{
                    height: "30vh",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      color: "red",
                      fontWeight: "600",
                      fontSize: "2rem",
                      fontFamily: fontFamily || "Poppins",
                    }}
                  >
                    No Orders Found
                  </p>
                </Grid>
              ) :
                data.data.length > 0 ?
                  (
                    <Grid container spacing={4}>
                      {data && data.data.length > 0 && data?.data?.map((order) => {
                        const orderDate = new Date(order.created_date);
                        const formattedDate = orderDate.toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        );
                        const formattedTime = orderDate.toLocaleTimeString(
                          "en-US",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        );
                        return (
                          <Grid item xs={12} md={6} key={order.id}>
                            <Card
                              className="p-4"
                              style={{
                                borderRadius: "20px",
                                border: "1px solid #DFDFDF",
                                backgroundColor: "#FAFAFA",
                              }}
                            >
                              <p style={{ fontSize: "18px", fontWeight: "700", fontFamily }}>
                                Order Id : {order?.order_id}
                              </p>
                              <div
                                className="d-flex mb-3"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "0.5rem",
                                  borderRadius: "5px",
                                  height: "5vh",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    width: "65%",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                    }}
                                  >
                                    <img
                                      src={calender}
                                      alt="Calendar"
                                      style={{
                                        height: "2vh",
                                        width: "2vh",
                                        marginRight: "0.8em",
                                        objectFit: "contain",
                                      }}
                                    />
                                    <p
                                      style={{
                                        margin: "0",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                        color: "#626264",
                                        fontFamily
                                      }}
                                    >
                                      {formattedDate}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      alt="Clock"
                                      style={{
                                        height: "2vh",
                                        width: "2vh",
                                        marginRight: "0.8em",
                                        objectFit: "contain",
                                      }}
                                    />
                                    <p
                                      style={{
                                        margin: "0",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                        color: "#626264",
                                        fontFamily
                                      }}
                                    >
                                      {formattedTime}
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "red",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                      height: "100%",
                                      marginTop: "0.3em",
                                      fontFamily
                                    }}
                                    onClick={() => handleClickOpen(order)}
                                  >
                                    View QR Code
                                  </p>
                                </div>
                              </div>
                              <p style={{ color: "#D6A40D", fontWeight: "600", fontFamily }}>
                                Show QR code when you arrive.
                              </p>
                              <div
                                style={{
                                  backgroundColor: "#EBEBEB",
                                  width: "100%",
                                  height: "15vh",
                                  borderRadius: "0.5rem",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "0px 0.5em",
                                }}
                              >
                                <div>
                                  <span
                                    style={{
                                      backgroundColor: "#B0DDB7",
                                      padding: "0.1rem",
                                      borderRadius: "0.8rem",
                                      fontSize: "0.7em",
                                      fontWeight: "600",
                                      color: "black",
                                      cursor: "pointer",
                                      padding: "0 0.5em",
                                      fontFamily
                                    }}
                                    className="mx-2"
                                  >
                                    Event
                                  </span>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      padding: "0 0.5rem",
                                      marginTop: "0.3em",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: fontSize || "0.8em",
                                        fontWeight: fontWeight || "600",
                                        fontFamily
                                      }}
                                    >
                                      {order?.event_name}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      padding: "0 0.5rem",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: fontSize || "0.6em",
                                        fontWeight: fontWeight || "500",
                                        fontFamily
                                      }}
                                    >
                                      {order?.event_address}
                                    </span>
                                  </div>
                                </div>
                                <div>
                                  <span
                                    style={{
                                      fontSize: fontSize || "14px",
                                      fontWeight: fontWeight || "600",
                                      color: "red",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                      height: "100%",
                                      marginTop: "0.3em",
                                      fontFamily
                                    }}
                                    onClick={() =>
                                      handleDialogOpen(order?.order_id)
                                    }
                                  >
                                    View Order Details
                                  </span>
                                </div>
                              </div>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  )
                  : (
                    <Grid
                      container
                      spacing={4}
                      style={{
                        height: "30vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          color: "red",
                          fontWeight: "600",
                          fontSize: "2rem",
                          fontFamily: fontFamily || "Poppins",
                        }}
                      >
                        No Orders Found
                      </p>
                    </Grid>
                  )}
            </Card>
          )}

          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth



            PaperProps={{
              style: {
                boxShadow: "none",
              },
            }}
          >
            <DialogActions>

              <div
                className=" d-flex h-100 w-100 justify-center items-center"
                style={{ height: "100%", justifyContent: "center", alignItems: "center", position: "relative" }}
              >
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "lightgray",
                    borderRadius: "2em",
                    padding: "0.4em",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    margin: "0.5rem",
                    right: "0",
                  }}
                  onClick={handleClose}
                >
                  <CloseIcon sx={{ color: "black" }} />
                </div>
                <div
                  className="d-flex h-100 justify-center items-center"
                  style={{
                    backgroundColor: "#FFF2CA",

                    minWidth: "7vw",
                    padding: "0.8rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "1em",
                    height: "100%",
                    fontWeight: "700",
                    fontSize: "1rem",
                  }}
                >
                  Order Id : {currentOrder?.order_id}
                </div>
              </div>
            </DialogActions>
            <DialogContent
              style={{
                fontWeight: "800",
                textAlign: "center",
                fontSize: "1.2rem",
              }}
            >
              Show QR code when you arrive
            </DialogContent>
            <DialogContent
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "5vh 0px",
              }}
            >
              <img
                src={currentQRCodeurl}
                alt="Popup Image"
                style={{ width: "40%", height: "70%" }}
              />
            </DialogContent>
            <div
              style={{
                padding: "0.2em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontWeight: "600",
                marginBottom: "5vh",
              }}
            >
              <CustomButton
                onClick={() => handleDownload(currentOrder?.order_id)}
                // onClick={() =>
                //   handleDownload(
                //     currentOrder?.qrcode,
                //     currentOrder?.event_name,
                //     currentOrder?.order_id
                //   )
                // }
                bgcolor="black"
                text="Download QR"
                width={"70%"}
                block={false}
                downLoadIcon={true}
              />
            </div>
          </Dialog>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
};

export default MyOrder;

const styles = {
  container: {
    borderRadius: "26px",
    border: "1px solid #D9D9D9",
    width: "45%",
    maxWidth: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    padding: "5px 10px",
    boxSizing: "border-box",
  },
  button: {
    backgroundColor: "#F6F2F2",
    border: "none",
    borderRadius: "20px",
    width: "30%",
    height: "100%",
    cursor: "pointer",
    fontSize: "18px",
  },
  input: {
    width: "40%",
    textAlign: "center",
    border: "none",
    outline: "none",
    fontSize: "16px",
  },
  quantityContainer: {
    width: "20%",
    disply: "flex",
    border: "1px solid #D9D9D9",
    borderRadius: "1rem",
  },
};
